<template>
    <div class="bottom-menu-bar">
        <div class="bottom-menu-item-half" v-bind:class="{'bottom-menu-item-half-active' : selectedGroupDataList.length > 0}" @click="moveGroupItem">
            <p><i class="bm-icon iconfont icon-yidong"></i></p>
            <p class="bm-text">移动</p>
        </div>
        <div class="bottom-menu-item-half" v-bind:class="{'bottom-menu-item-half-active' : selectedGroupDataList.length > 0}" @click="deleteGroupItem">
            <p><i class="bm-icon iconfont icon-shanchu"></i></p>
            <p class="bm-text">删除</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GroupBottomBar',
    computed: {
        selectedGroupDataList(){
            return this.$store.state.group.selectedGroupDataList;
        }
    },
    methods:{
        moveGroupItem() {
            if(this.selectedGroupDataList.length > 0){
                this.$store.dispatch('group/toggleChangeGroup', true);
            }
        },
        deleteGroupItem() {
            if(this.selectedGroupDataList.length > 0){

                this.$dialog.confirm({
                    message: '确定要删除选中的八字记录吗？'
                }).then(() => {
                    // on confirm
                    this.$store.dispatch('group/deleteGroupListData');
                }).catch(() => {
                    // on cancel
                    instance.close();
                }); 

            }
        }
    }
}
</script>